import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CoupleProfileCard = ({ coupleData, onEditProfile }) => {
  const calculateRelationshipDuration = (startDate) => {
    const start = new Date(startDate);
    const now = new Date();
    const years = now?.getFullYear() - start?.getFullYear();
    const months = now?.getMonth() - start?.getMonth();
    
    if (years > 0) {
      return `${years} year${years > 1 ? 's' : ''} ${months > 0 ? `${months} month${months > 1 ? 's' : ''}` : ''}`;
    }
    return `${months} month${months > 1 ? 's' : ''}`;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-therapeutic">
      <div className="flex flex-col lg:flex-row items-center lg:items-start gap-4 md:gap-6 lg:gap-8">
        <div className="flex items-center gap-3 md:gap-4 lg:gap-6">
          <div className="relative">
            <Image
              src={coupleData?.partner1?.avatar}
              alt={coupleData?.partner1?.avatarAlt}
              className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-full object-cover border-2 border-primary"
            />
            <div className="absolute -bottom-1 -right-1 w-5 h-5 md:w-6 md:h-6 bg-success rounded-full border-2 border-card" />
          </div>

          <div className="hidden lg:flex items-center justify-center">
            <Icon name="Heart" size={32} color="var(--color-accent)" />
          </div>

          <div className="relative">
            <Image
              src={coupleData?.partner2?.avatar}
              alt={coupleData?.partner2?.avatarAlt}
              className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-full object-cover border-2 border-primary"
            />
            <div className="absolute -bottom-1 -right-1 w-5 h-5 md:w-6 md:h-6 bg-success rounded-full border-2 border-card" />
          </div>
        </div>

        <div className="flex-1 text-center lg:text-left">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
            {coupleData?.partner1?.name} & {coupleData?.partner2?.name}
          </h2>
          
          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 md:gap-4 mb-3 md:mb-4">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Calendar" size={16} color="currentColor" />
              <span className="text-sm md:text-base">
                Together {calculateRelationshipDuration(coupleData?.relationshipStart)}
              </span>
            </div>
            
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="MapPin" size={16} color="currentColor" />
              <span className="text-sm md:text-base">{coupleData?.location}</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-4">
            {coupleData?.relationshipGoals?.map((goal, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-primary/10 text-primary rounded-md text-xs md:text-sm font-caption"
              >
                {goal}
              </span>
            ))}
          </div>

          <p className="text-sm md:text-base text-muted-foreground mb-4 max-measure mx-auto lg:mx-0">
            {coupleData?.recentActivity}
          </p>

          <button
            onClick={onEditProfile}
            className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-md hover:bg-muted/80 transition-therapeutic text-sm md:text-base"
          >
            <Icon name="Settings" size={18} color="currentColor" />
            <span>Edit Profile</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoupleProfileCard;